export class EmailAddressDto {
  emailAddress: string;
  id: string;
  type = 'WORK';

  constructor(d?: EmailAddressDto) {
    if (!d) {
      return;
    }
    this.emailAddress = d.emailAddress;
    this.id = d.id;
    this.type = d.type;
  }
}
